import GUIONES from "@/components/tutoriales/guiones.json";
import AUDIOS from "@/components/tutoriales/audios.json";
import { desbloquearAudio } from "@/components/tutoriales/sonido";

import { CONTRATOS_VISIBLE } from "@/lib/modulos";

export const TUTORIALES = GUIONES.filter((t) => CONTRATOS_VISIBLE || t.id !== "contratos");
export const tutorialDe = (id) => GUIONES.find((t) => t.id === id);
export const tutorialDeNav = (navId) => GUIONES.find((t) => t.navId === navId);
export const audioDe = (id, n) => (AUDIOS[`${id}-${n}`] ? `/tutoriales/audio/${AUDIOS[`${id}-${n}`]}` : null);

export const ABRIR_TUTORIAL = "nuvlipro:abrir-tutorial";
export const abrirTutorial = (id) => {
  desbloquearAudio();
  window.dispatchEvent(new CustomEvent(ABRIR_TUTORIAL, { detail: id }));
};

// Duración aproximada: unas 14 letras por segundo de voz más el movimiento del cursor (o la medida exacta si el guion la trae).
export const duracion = (t) => (t.duracion ? `${t.duracion} s` : `${Math.round(t.pasos.reduce((s, p) => s + Math.max(4, p.texto.length / 14) + 1.6, 0) / 5) * 5} s`);

export const ETIQUETA_TUTORIAL = /\[\[tutorial:([a-z]+)\]\]/;
export const sinEtiqueta = (t) => t.replace(/\[\[tutorial:[a-z]*\]?\]?/g, "").replace(/\[\[?t?u?t?o?r?i?a?l?:?$/, "").trimEnd();
